import { useId } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { unthemed } from 'tokens';

interface MoonProps {
	progress: number;
	size: number;
	isBreathing?: boolean;
}

const moonBreathe = keyframes`
	0%, 100% { opacity: 1; }
	50% { opacity: 0.45; }
`;

const Wrap = styled.div<{ $size: number; $isBreathing: boolean }>`
	position: relative;
	width: ${(p) => p.$size}px;
	height: ${(p) => p.$size}px;
	display: flex;
	align-items: center;
	justify-content: center;
	${(p) =>
		p.$isBreathing &&
		css`
			animation: ${moonBreathe} 2.6s ease-in-out infinite;
		`}
`;

const Moon = ({ progress, size, isBreathing = false }: MoonProps) => {
	const maskId = `moon-mask-${useId()}`;
	const cx = 50;
	const cy = 50;
	const r = 42;
	const clamped = Math.max(0, Math.min(1, progress));
	const shadowOffsetX = 2 * r * clamped;
	return (
		<Wrap $size={size} $isBreathing={isBreathing}>
			<svg width={size} height={size} viewBox="0 0 100 100">
				<defs>
					<mask id={maskId}>
						<rect x="0" y="0" width="100" height="100" fill="black" />
						<circle cx={cx} cy={cy} r={r} fill="white" />
						<circle cx={cx + shadowOffsetX} cy={cy} r={r} fill="black" />
					</mask>
				</defs>
				<circle
					cx={cx}
					cy={cy}
					r={r}
					fill="none"
					stroke={unthemed.gray[100]}
					strokeOpacity={0.2}
					strokeWidth={1}
				/>
				<circle cx={cx} cy={cy} r={r} fill={unthemed.gray[100]} mask={`url(#${maskId})`} />
			</svg>
		</Wrap>
	);
};

export default Moon;
